var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BTC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bitcoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1",
    fill: "#F8921A",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1289071,20.2929408 C39.7328568,16.0678046 36.2302648,14.5862549 31.8101077,14.0981276 L31.8014189,8.24792948 L28.3776085,8.18212782 L28.386165,13.8781366 C27.4860923,13.8608641 26.5660695,13.8615712 25.6520139,13.8628749 L25.6441135,8.12916786 L22.2221386,8.06292553 L22.2294489,13.9114254 C21.488199,13.9128412 20.7602585,13.9130909 20.0504361,13.8998594 L20.0499616,13.8817103 L15.3276762,13.7887643 L15.3341505,17.5920063 C15.3341505,17.5920063 17.8624354,17.5907424 17.8204797,17.6383558 C19.2073081,17.6655951 19.6598986,18.511688 19.7922474,19.2368147 L19.802323,25.9014136 C19.8980222,25.9038036 20.0228701,25.9103563 20.1642552,25.933231 C20.0501972,25.9311901 19.9281061,25.928034 19.8025742,25.9267186 L19.8154,35.2631462 C19.7552031,35.7159108 19.4997092,36.4347182 18.5307899,36.4177405 C18.5746578,36.458954 16.0419343,36.3689538 16.0419343,36.3689538 L15.3678875,40.6085052 L19.8235,40.6944508 C20.6526603,40.7114995 21.4685215,40.7418871 22.2694578,40.7626679 L22.2795806,46.6794861 L25.6997199,46.7461691 L25.6910277,40.8919134 C26.6301317,40.9302537 27.5389319,40.955577 28.4261523,40.9718767 L28.4332149,46.7991291 L31.8570254,46.8649308 L31.849436,40.958665 C37.6050633,40.726417 41.6316071,39.2960515 42.123639,33.6837991 C42.5209113,29.1647126 40.4704923,27.1052245 37.2018076,26.226002 C39.1853348,25.2130693 40.4236987,23.3847144 40.1289071,20.2929408 L40.1289071,20.2929408 L40.1289071,20.2929408 Z M35.3573453,32.851866 C35.365727,37.2735636 28.0855382,36.6299409 25.7651333,36.587385 L25.7545092,28.7479966 C28.0756051,28.7934305 35.3508659,28.2399791 35.3573453,32.851866 L35.3573453,32.851866 L35.3573453,32.851866 Z M25.749137,25.1595878 L25.7389089,18.0496107 C27.6717015,18.0868067 33.7421695,17.5648889 33.7487511,21.7607602 C33.7535778,25.783554 27.6819296,25.1967839 25.749137,25.1595878 L25.749137,25.1595878 Z",
    id: "symbol",
    fill: "#FFFFFF",
    transform: "translate(28.750176, 27.463928) rotate(15.000000) translate(-28.750176, -27.463928) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img-1.d186c3e35f1e41df3bc3ab38a91e93b4.svg";
export { ForwardRef as ReactComponent };